<template>
    <svg height="2" viewBox="0 0 24 2" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform="translate(0 -11)"><path class="filled" d="m11 0h2v24h-2z" fill="#f26363" transform="matrix(0 -1 1 0 0 24)"/><path d="m0 0h24v24h-24z"/></g></svg>
</template>
